import { render, staticRenderFns } from "./cxyq2023.vue?vue&type=template&id=3a8f4981&scoped=true"
import script from "./cxyq2023.vue?vue&type=script&lang=js"
export * from "./cxyq2023.vue?vue&type=script&lang=js"
import style0 from "./cxyq2023.vue?vue&type=style&index=0&id=3a8f4981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f4981",
  null
  
)

export default component.exports